import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { BUCKET_COLORS } from "@/lib/constants";
import { formatCompact } from "@/lib/format";

export const AllocationDonut = ({ inputs, result, currency }) => {
  const isBucket = inputs.strategy === "bucket";

  const data = isBucket
    ? inputs.buckets.map((b, i) => ({
        name: b.name,
        value: result.retirementCorpus * (b.allocation / 100),
        pct: b.allocation,
        ret: b.return,
        color: BUCKET_COLORS[i],
      }))
    : [{ name: "Portfolio", value: result.retirementCorpus, pct: 100, ret: inputs.swpReturn, color: "#2D6A4F" }];

  const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload || !payload.length) return null;
    const d = payload[0].payload;
    return (
      <div className="rounded-xl border border-[#E8E3D9] bg-white px-3 py-2 shadow-lg text-xs">
        <div className="font-heading font-bold text-[#1A231F]">{d.name}</div>
        <div className="text-[#5C6A64]">{formatCompact(d.value, currency)} · {d.pct}%</div>
        <div className="text-[#8A9790]">Return @ {d.ret}%</div>
      </div>
    );
  };

  return (
    <div className="bg-white rounded-2xl border border-[#E8E3D9] shadow-sm p-6" data-testid="allocation-donut">
      <h3 className="font-heading text-lg font-semibold text-[#1A231F] mb-1">Asset Allocation</h3>
      <p className="text-sm text-[#8A9790] mb-3">{isBucket ? "3-bucket split at retirement" : "Simple SWP portfolio"}</p>
      <div className="flex items-center gap-4">
        <div className="h-[150px] w-[150px] shrink-0">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie data={data} dataKey="value" innerRadius={45} outerRadius={70} paddingAngle={2}
                stroke="none" animationDuration={700}>
                {data.map((d, i) => (
                  <Cell key={i} fill={d.color} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="flex-1 space-y-2">
          {data.map((d, i) => (
            <div key={i} className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2">
                <span className="h-3 w-3 rounded-full" style={{ backgroundColor: d.color }} />
                <span className="text-[#1A231F] font-medium">{d.name}</span>
              </div>
              <span className="font-mono text-[#5C6A64]">{d.pct}% · {d.ret}%</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
